import Text from '../Text';
import { COLORS, fontSizes } from '../../constants/constants';
import { cn } from '../../utils/utils';
import ErrorText from './ErrorText';
import { useSelector } from 'react-redux';
import { getRejectedFieldData, getSectionRejectedFields, isRequiredEmpty } from '../../utils/functions';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import ViewReverse from '../ViewReverse';
import ViewItems from '../ViewItems';
import DatePicker, { Calendar, DateObject } from 'react-multi-date-picker';
import arabic from 'react-date-object/calendars/arabic';
import arabic_ar from 'react-date-object/locales/arabic_en';
import dynamicfunction from '../../utils/dynamicfunction';
import InputIcon from 'react-multi-date-picker/components/input_icon';
import { CalendarIcon } from '@mui/x-date-pickers';
import InputField from './InputField';

const HijriDatePicker = ({
  label,
  divClasses,
  className,
  onChange,
  labelColor = 'text-primary-light',
  placeholder,
  selectedDate,
  isRequired = false,
  maxDate,
  minDate,
  isDisabled = false,
  labelDivClass,
  isLabelHeight = false,
  error,
  remarksMetadata = null,
}) => {
 const { isArabic } = dynamicfunction();
  const { rejection_summary, is_rejected, field_codes } = useSelector((state) => state.corporate);

  const rejectedFields = getSectionRejectedFields(rejection_summary, remarksMetadata?.sectionId);
  const rejectedField = rejectedFields?.length < 1 ? null : getRejectedFieldData(rejectedFields, field_codes, remarksMetadata?.key);

  const isFieldDisabled = isDisabled || (is_rejected && remarksMetadata && !rejectedField?.remarks);

  const handleChange = (val) => {
    if (onChange) {
      onChange(val ? val : null);
    }
  };

  return (
    <ViewItems className={cn('w-full', divClasses)}>
      {label && (
        <div data-required-empty={isRequiredEmpty(isRequired, label, selectedDate)} className={cn(isLabelHeight ? 'md:h-9' : 'h-6', labelDivClass)}>
          <Text text={label} size={fontSizes.h14} color={labelColor} className={'mb-1 leading-4'} isRequired={isRequired} />
        </div>
      )}
      <div className={cn('border border-grey rounded py-[3px] px-2 w-full', className,
        isFieldDisabled && 'bg-disabled cursor-not-allowed',
        rejectedField?.remarks?.length > 0 && 'border-red-600'
      )}>
        <DatePicker
          value={selectedDate}
          onChange={(_, hijriDate) => {
            handleChange(hijriDate?.validatedValue?.toString() ?? '');
          }}
          calendar={arabic}
          locale={arabic_ar}
          currentDate={new DateObject({ calendar: arabic })}
          minDate={minDate ? new DateObject({ calendar: arabic, date: minDate }) : undefined}
          maxDate={maxDate ? new DateObject({ calendar: arabic, date: maxDate }) : undefined}
          placeholder={placeholder}
          disabled={isFieldDisabled}
          containerClassName='custom-hijri-calendar w-full'
          className='w-full'
          style={{
            height: '30px',
            border: 'none',
            outline: 'none',
            fontSize: '14px',
            padding: '5px',
          }}
          mapDays={({ date, today }) => {
            let props = {};
            if (today.day === date.day) {
              props.className = 'today-highlight';
            }
            return props;
          }}
          render={(value, openCalendar) => {
            return (
              <div className="relative w-full flex items-center">
                <InputField
                  value={value}
                  onClick={openCalendar}
                  placeholder={placeholder}
                  readOnly
                  disabled={isFieldDisabled}
                  className={cn(
                    'w-full h-[30px] border-none outline-none text-sm bg-transparent pr-8 padding-[5px]',
                    isArabic && 'text-end pl-8 pr-[5px]', 
                    isFieldDisabled && 'text-dark-grey/50 cursor-not-allowed'
                  )}
                />
                <span
                  onClick={!isFieldDisabled ? openCalendar : undefined}
                  className={cn(
                    "absolute cursor-pointer text-gray-500 hover:text-gray-700 select-none",
                    isArabic ? "left-2" : "right-2",
                    isFieldDisabled && "cursor-not-allowed opacity-50"
                  )}
                >
                  <CalendarIcon/>
                </span>
              </div>
            );
          }}
        />
      </div>
      {error?.length > 0 && <ErrorText text={error} />}
      {
        rejectedField?.remarks?.length > 0 && (
          <ViewReverse className='items-center gap-2 mt-2'>
            <ReactSVG src={icons.field_info_outline} />
            <ErrorText text={rejectedField?.remarks} className={'mt-0'} />
          </ViewReverse>
        )
      }
    </ViewItems>
  );
};

export default HijriDatePicker;
